// extracted by mini-css-extract-plugin
export default {"notification":"NotificationPopup_notification__OTY+K"};